module.exports = __webpack_public_path__ + "media/images/marisol-play2-8689df854d5740fd7bef45899027a802.jpg";